// Layer 3 (Transformations / seed data): pure data, no React. The canonical
// demo project records — the portfolio table, sidebar module nav, TopBar
// switcher, and Home cards all derive from this single list.
//
// parity.P5: mirrors ai-foundation's ProjectTile + ProjectTileCounts shape
// (src/app/(app)/projects/ProjectsGrid.tsx) with the mock's slug routing.

import type { ProjectColor } from './project-colors';

export type ProjectTile = {
  slug: string;
  name: string;
  description: string;
  color: ProjectColor;
  /** ms epoch */
  createdAt: number;
  /** ms epoch */
  updatedAt: number;
  threadCount: number;
  fileCount: number;
  /** ms epoch of last chat/file touch; null = never */
  lastActivityAt: number | null;
  /** Portfolio "Owner" column — 'owner' renders as "You". */
  viewerRole: 'owner' | 'member' | 'viewer';
};

const now = Date.now();
const hour = 60 * 60 * 1000;
const day = 24 * hour;

export const PROJECT_TILES: ProjectTile[] = [
  {
    slug: 'alpha',
    name: 'Project Alpha',
    description: 'Example project — shows the module rail in project mode.',
    color: 'crimson',
    createdAt: now - 42 * day,
    updatedAt: now - 2 * hour,
    threadCount: 3,
    fileCount: 12,
    lastActivityAt: now - 2 * hour,
    viewerRole: 'owner',
  },
  {
    slug: 'beta',
    name: 'Project Beta',
    description: 'Second demo project — proves the project switcher.',
    color: 'moss',
    createdAt: now - 30 * day,
    updatedAt: now - 3 * day,
    threadCount: 1,
    fileCount: 4,
    lastActivityAt: now - 3 * day,
    viewerRole: 'owner',
  },
  {
    slug: 'gamma',
    name: 'Field Study Gamma',
    description: 'Shared demo project — exercises the portfolio "Shared" pill.',
    color: 'ochre',
    createdAt: now - 12 * day,
    updatedAt: now - 26 * hour,
    threadCount: 2,
    fileCount: 7,
    lastActivityAt: now - 26 * hour,
    viewerRole: 'member',
  },
  {
    slug: 'delta',
    name: 'Archive Delta',
    description: 'Dormant demo project — no recent activity.',
    color: 'slate',
    createdAt: now - 90 * day,
    updatedAt: now - 21 * day,
    threadCount: 0,
    fileCount: 2,
    lastActivityAt: null,
    viewerRole: 'owner',
  },
];

export function projectTileBySlug(slug: string | undefined): ProjectTile | null {
  return PROJECT_TILES.find((p) => p.slug === slug) ?? null;
}
